<template>
  <cx-showcase-section :name="name" :link="link" class="cx-tab-control-showcase">
    <cx-tab-control :tabs="views">
    </cx-tab-control>
    <cx-tab-control :tabs="singleView">
    </cx-tab-control>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxTabControl from '@/components/CxTabControl';

export default {
  name: 'CxTabControlShowcase',
  components: {
    CxShowcaseSection,
    CxTabControl
  },
  data() {
    return {
      name: 'CxTabControl',
      link: '#',
      views: [
        {
          id: 1,
          title: 'Tab1',
          component: 'CxTestTab'
        },
        {
          id: 2,
          title: 'Tab with prop',
          props: {
            text: 'Some text from props'
          },
          component: 'CxTestTab'
        },
        {
          id: 3,
          title: 'Tab with custom title class',
          component: 'CxTestTab',
          titleClass: 'custom-title-class'
        },
        {
          id: 4,
          title: 'Tab with custom content',
          component: 'CxTestTab',
          props: {
            text: 'Look! Different background color'
          },
          contentClass: 'custom-content-class'
        }
      ],
      singleView: [
        {
          id: 1,
          title: 'Single Tab',
          props: {
            text: 'This is only tab in controller'
          },
          component: 'CxTestTab'
        }
      ]
    };
  },
  methods: {
    async toggle(item) {
      item.loading = true;
      await Promise.resolve(setTimeout(1000));
      item.loading = false;
      item.active = !item.active;
    },
  },
};

</script>

<style lang="less">
@import '../../../common';

.custom-title-class {
    text-align: center;
    display: flex;
    align-content: center;
    align-items: center;
    width: 100%;
    font-size: 20px;
    padding-bottom: 5px;
    background-color: rgba(85, 85, 85, 0.116)
}

.custom-title-class.selected {
  color: #C4C4C4;
  border-bottom: solid 3px white;
  font-weight: 700;
}

.custom-content-class {
  background-color: rgba(78, 102, 138, 0.5);
}

</style>